import { createContext } from 'react';

export const UserGroupContext = createContext({ groups: [] });
